import React from 'react'
import CallbackContainer from '../containers/AuthorizationProvider/Callback.container'

/**
 * The Callback' page.
 */
const Callback = props => <CallbackContainer {...props} />

export default Callback
